import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t } from '../../../../../services/i18n';
import { Colors } from '../../../../../styles/Colors';
import AppText from '../../../../common/AppText';
import CustomCheckbox from '../../../../common/CustomCheckbox';
import { closeModal, openModal, STEPPER_CONFIRM_MODAL } from '../../../../../redux/modalManagerSlice';
import { setError } from '../../../../../redux/stepperSlice';
import VStack from '../../../../common/Layout/VStack';

const CHECKBOX_OPTIONS = [
    { key: 'send_customer_tax_invoice_receipt', langKey: 'documentsAutoSendTaxInvoiceReceipt' },
    { key: 'send_customer_payment_receipt', langKey: 'documentsAutoSendPaymentReceipt' },
    { key: 'send_customer_tax_invoice', langKey: 'documentsAutoSendTaxInvoice' },
];

const DocumentsAutoSendSettings = ({ values, setFieldValue, handleSubmit }) => {
    const dispatch = useDispatch();
    const stepperError = useSelector((state) => state.stepper.error);

    useEffect(() => {
        if (stepperError?.message !== 'confirm-documents-auto-send-off') return;
        dispatch(setError(null));
        dispatch(openModal({
            modalName: STEPPER_CONFIRM_MODAL,
            props: {
                header: t('areYouSure'),
                subheader: t('documentsAutoSendAllUncheckedConfirm'),
                confirmText: t('confirm'),
                cancelText: t('cancel'),
                onConfirm: () => {
                    dispatch(closeModal({ modalName: STEPPER_CONFIRM_MODAL }));
                    setFieldValue('confirmed', true);
                    handleSubmit();
                    dispatch(setError(null));
                },
                onCancel: () => {
                    dispatch(closeModal({ modalName: STEPPER_CONFIRM_MODAL }));
                    dispatch(setError(null));
                },
            },
        }));
    }, [stepperError]);

    return (
        <VStack space="1rem">
            <VStack space="0.75rem">
                {CHECKBOX_OPTIONS.map((option) => (
                    <CustomCheckbox
                        key={option.key}
                        text={t(option.langKey)}
                        isChecked={values[option.key]}
                        onChange={(checked) => setFieldValue(option.key, checked)}
                    />
                ))}
            </VStack>
            <AppText style={{ color: Colors.newDesign.darkGrey, fontSize: 12 }}>{t('documentsAutoSendDisclaimer')}</AppText>
        </VStack>
    );
};

export default DocumentsAutoSendSettings;
